import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import SvgIcon from '../SvgIcon';

var ArrowRight = function ArrowRight(props) {
  return _jsx(SvgIcon, __assign({}, props, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.4343 6.43427C13.7467 6.12185 14.2532 6.12185 14.5656 6.43427L19.5656 11.4343C19.8781 11.7467 19.8781 12.2532 19.5656 12.5656L14.5656 17.5656C14.2532 17.8781 13.7467 17.8781 13.4343 17.5656C13.1218 17.2532 13.1218 16.7467 13.4343 16.4343L17.0686 12.8H4.99995C4.55812 12.8 4.19995 12.4418 4.19995 12C4.19995 11.5581 4.55812 11.2 4.99995 11.2H17.0686L13.4343 7.56564C13.1218 7.25322 13.1218 6.74669 13.4343 6.43427Z"
    })
  }));
};

export default ArrowRight;